<template>
  <div class="content">
    <div style="display: none!important;">
      <electron-vue-printer
        ref="electronVuePrinter"
        :show="true"
        :options="options"
        :rotateType="rotateType"
        @webview-ready="Printer"
        :silent="true"
      >
      </electron-vue-printer>
    </div>
    {{print}}
    <div id="my-node">
      <div style="padding: 15px;">
      <h5>
        <span v-if="datas.sklad"
          ><b>{{ datas.sklad.name }}</b></span
        >
        <span style="float: right;" v-if="datas.created_at>0"
          >{{ $t("Сана") }}:
          <b>{{ new Date(datas.created_at*1000).toISOString().substr(0, 10) }}</b></span
        ><br />
        {{ $t("Етказувчи") }}:
        <span v-if="datas.kontragent"
          ><b>{{ datas.kontragent.name }}</b></span
        >
        <b style="float: right;">№{{ datas.id }}</b>
      </h5>
      <ul v-for="(item, index) in datas.prixod_table" :key="index" class="product-row">
        <li>
          {{ index + 1 }}.<span v-if="item.product">{{
            item.product.extra_name || item.product.name
          }}</span>
        </li>
        <li class="product-calculation">
          <span>{{ formatMoney(item.count) }} x {{ formatMoney(item.kontragent_price) }}</span>
          <b class="currency-amount">
            {{ isDollarItem(item) ? '$' : '' }}{{ formatMoney(item.kontragent_summa) }}{{ isDollarItem(item) ? '' : " so'm" }}
          </b>
        </li>
      </ul>
      <div class="currency-summary">
        <div class="summary-row som-row">
          <span>JAMI SO'M</span>
          <b>{{ formatMoney(somTotal) }} so'm</b>
        </div>
        <div class="summary-row dollar-row">
          <span>JAMI DOLLAR</span>
          <b>${{ formatMoney(dollarTotal) }}</b>
        </div>
      </div>
      <h5 style="text-align: center;" v-if="datas.kontragent">
        {{ $t("Қолдиқ сумма") }}: {{ qarz }} so'm<br>
        {{ $t("Қолдиқ сумма") }} $: {{ qarz_dollar }}
      </h5>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import electronVuePrinter from "electron-vue-printer";
export default {
  name: "Print",
  components: { electronVuePrinter, htmlToImage },
  data() {
    return {
      datas: [],
      mysklad: [],
      dataUrl:null,
      print:'false',
      printer: '',
      rotateType: 0,
      options: {
        offsetX: 0,
        offsetY: 0,
        imageWidth: 300
      },
      qarz: 0,
      qarz_dollar: 0
    };
  },
  created: function() {
    this.Data();
    this.GetPrinterName();
  },
 async updated(){
    if(this.print=='print'){
      this.$refs.electronVuePrinter.deviceNamePrint = this.printer.check_printer_name;
      await this.$refs.electronVuePrinter.print(this.dataUrl);
    }
  },
  methods: {
    isDollarItem(item) {
      return Number(item && item.price_type) === 2;
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('ru-RU', { maximumFractionDigits: 3 });
    },
    GetPrinterName(){
      let self = this;
      axios({
        method: "post",
        url: "api/v1/sklad-settings",
        data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
      }).then(function (response) {
        if (response.data.data != null) {
          self.printer = JSON.parse(response.data.data);
        }
      });
    },
    Starprinting(data){
      if(data==true){
        window.close();
      }
    },
    Data() {
      let self = this;
      axios
        .get("api/v1/prixod/id/" + self.$route.params.id)
        .then(function(response) {
          self.datas = response.data;
          self.Mysklad();
          self.Qarzdorlik();
        });
    },
    data_await(){
      let self = this;
      if(self.printer.check_printer_name){
        self.Starprinting(true)   
      }else{
        self.data_await()
      }
      
    },
    async Printer() {
      let self = this;
      var node = document.getElementById("my-node");
      await htmlToImage
        .toSvg(document.getElementById("my-node"))
        .then(function(dataUrl) {
          self.dataUrl=dataUrl;
            self.print='print';  
            setTimeout(() => {
                self.data_await()
              }, 3000);          
        })
        .catch(function(error) {
          console.error("oops, something went wrong!", error);
        });
    },
    Qarzdorlik() {
      let self = this;
      self.qarz = 0;
      self.qarz_dollar = 0;
      axios({
        method: "post",
        url: "api/v1/kontragent/total",
        data: {
          kontragent_id: self.datas.kontragent_id,
          sklad_id: self.datas.sklad_id,
          datetime: self.datas.created_at
        }
      }).then(function(response) {
        response.data.forEach(function (key) {
          if (key.pay_type_id == 3) {
            self.qarz_dollar = key.total;
          } else {
            self.qarz += key.total;
          }
        });
        self.print=true;
      });
    },
    Mysklad() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/sklads/id/" + self.datas.sklad_id
      }).then(function(response) {
        self.mysklad = response.data;
      });
    }
  },
  computed: {
    somTotal() {
      return (this.datas.prixod_table || []).reduce((sum, item) =>
        sum + (this.isDollarItem(item) ? 0 : Number(item.kontragent_summa || 0)), 0);
    },
    dollarTotal() {
      return (this.datas.prixod_table || []).reduce((sum, item) =>
        sum + (this.isDollarItem(item) ? Number(item.kontragent_summa || 0) : 0), 0);
    },
  },
  watch: {
    "$store.state.changed": function() {
      if (this.$store.state.changed != null) {
        this.Ostatka(this.$store.state.selected_index);
        this.$store.state.changed = null;
      }
    }
  }
};
</script>
<style scoped>
#my-node {
  width: 300px;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

h5 {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

ul {
  list-style: none;
  border-bottom: 1px dotted;
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: black;
}
.product-row {
  padding: 5px 0;
  border-bottom: 2px solid #000;
}
.product-calculation,
.summary-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.currency-amount { white-space: nowrap; }
.currency-summary {
  border: 2px solid #000;
  margin-top: 7px;
}
.summary-row {
  padding: 6px;
  font-size: 13px;
  font-weight: 800;
}
.summary-row + .summary-row { border-top: 2px solid #000; }
.som-row { background: #f3f4f6; }
.dollar-row { background: #e8f5e9; }
</style>
